import { DISTRIBUTOR_EXTENDED_PARAMETERS_SERVICE_NAME, DistributorExtendedParametersServiceProvider } from './distributor.extended-parameters.service'
import { DISTRIBUTOR_HIERARCHY_SERVICE_NAME, DistributorHierarchyServiceProvider } from './distributor.hierarchy.service'
import { DISTRIBUTOR_ROLE_SERVICE_NAME, DistributorRoleServiceProvider } from './distributor.role.service'
import { DISTRIBUTOR_SERVICE_NAME, DistributorServiceProvider } from './distributor.service'
import { DISTRIBUTOR_SUPPLIER_SERVICE_NAME, DistributorSupplierServiceProvider } from './distributor.supplier.service'

export const DISTRIBUTOR_SERVICES_MODULE_NAME = 'simax.services.distributor'

const module = angular.module(DISTRIBUTOR_SERVICES_MODULE_NAME, [])

module.provider(DISTRIBUTOR_EXTENDED_PARAMETERS_SERVICE_NAME, DistributorExtendedParametersServiceProvider)
module.provider(DISTRIBUTOR_HIERARCHY_SERVICE_NAME, DistributorHierarchyServiceProvider)
module.provider(DISTRIBUTOR_ROLE_SERVICE_NAME, DistributorRoleServiceProvider)
module.provider(DISTRIBUTOR_SERVICE_NAME, DistributorServiceProvider)
module.provider(DISTRIBUTOR_SUPPLIER_SERVICE_NAME, DistributorSupplierServiceProvider)
